export default __webpack_public_path__ + "static/media/BBQ.687ba3de.svg";